module.exports = __webpack_public_path__ + "media/src/assets/Images/LegalDepartment-4003903daeec0dce1fc3d384c9ba6cf3.svg";